export enum QuestionHelpContentTypeCode {
  QUESTION_PURPOSE = 'QUESTION_PURPOSE',
  QUESTION_PURPOSE_LINK = 'QUESTION_PURPOSE_LINK',
  ANSWER_GUIDE = 'ANSWER_GUIDE',
  CAUTION = 'CAUTION',
  GOOD_ANSWER = 'GOOD_ANSWER',
  BAD_ANSWER = 'BAD_ANSWER',
  SIMILAR_QUESTION_ANSWER = 'SIMILAR_QUESTION_ANSWER',
}

export interface QuestionHelpSimpleContent {
  value: string;
}

export interface QuestionHelpDetailContent extends QuestionHelpSimpleContent {
  title: string;
}

export interface QuestionHelpContentMap {
  [QuestionHelpContentTypeCode.QUESTION_PURPOSE]: QuestionHelpSimpleContent[];
  [QuestionHelpContentTypeCode.QUESTION_PURPOSE_LINK]: QuestionHelpSimpleContent[];
  [QuestionHelpContentTypeCode.ANSWER_GUIDE]: QuestionHelpSimpleContent[];
  [QuestionHelpContentTypeCode.CAUTION]: QuestionHelpSimpleContent[];
  [QuestionHelpContentTypeCode.GOOD_ANSWER]: QuestionHelpDetailContent[];
  [QuestionHelpContentTypeCode.BAD_ANSWER]: QuestionHelpDetailContent[];
  [QuestionHelpContentTypeCode.SIMILAR_QUESTION_ANSWER]: QuestionHelpDetailContent[];
}

export interface QuestionAnswerResultRs {
  pooledQuestionSn: number;
  questionText: string;
  dateTime: string;
  companyName: string;
  companySn: number;
  helpContents: QuestionHelpContentMap | null;
}
